import { ApiClient } from "@/api/shared/api-client";
import type { ApiResponse } from "@/models/api-response";
import type { Organization } from "@/features/organizations/models/organization";

export class OrganizationsClient extends ApiClient {
  public getOrganizationsList({
    productToken,
  }: {
    productToken: string;
  }): Promise<ApiResponse<Organization[]>> {
    return this.get<Organization[]>({
      url: "/v1/manage/organizations",
      headers: {
        Authorization: `Bearer ${productToken}`,
      },
    });
  }
}
